import React from 'react';

const ConsentsContext = React.createContext([]);

export default ConsentsContext;